import { getCoprincipalAccountForMailboxInfo } from "owa-account-source-list-store";
import { isMailboxSharedOrDelegate } from "owa-account-shared-mailbox-utils";
import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export function getCopilotRequestCustomHeaders(mailboxInfo: MailboxInfo): Record<string, string> {
    if (!isGlobalFeatureEnabled("acct-enable-shared-in-bizchat") ||
        !isMailboxSharedOrDelegate(mailboxInfo)) {
        return {};
    }
    
    const authenticatingUserIdentifiers = getCoprincipalAccountForMailboxInfo(mailboxInfo)?.authenticatingUserIdentifiers;
    
    return authenticatingUserIdentifiers?.puid && authenticatingUserIdentifiers.tenantId
        ? {
            "x-anchormailbox": `PUID:${authenticatingUserIdentifiers.puid}@${authenticatingUserIdentifiers.tenantId}`,
        }
        : {};
}
